// @ts-check

import React from "react";
import { BlockStack, Grid } from "@shopify/polaris";

import { StatBox } from "components/StatBox/StatBox";

export const AdPropertyStats = ({
  loading,
  totalSpend,
  totalRevenue,
  totalClicks,
  totalOrders,
  roas,
  cac,
  aov,
  impressions,
  conversionRate,
  newCustomers,
}) => {
  return (
    <BlockStack gap="400">
      <Grid>
        <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
          <StatBox
            title="Total orders"
            description="How many orders you got from this ad"
            value={totalOrders}
            loading={loading}
          />
        </Grid.Cell>
        <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
          <StatBox
            title="New customers"
            description="How many unique new customers were acquired through this ad"
            value={newCustomers}
            loading={loading}
          />
        </Grid.Cell>
        <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
          <StatBox
            title="Total revenue"
            description="Total revenue from orders attributed to this ad"
            value={totalRevenue}
            loading={loading}
          />
        </Grid.Cell>
        <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 3, lg: 3, xl: 3 }}>
          <StatBox
            title="AOV"
            description="Average Order Value - how much the average order is worth"
            value={aov}
            loading={loading}
          />
        </Grid.Cell>
      </Grid>

      <Grid>
        <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 2, lg: 4, xl: 4 }}>
          <StatBox
            title="Total spend"
            description="Total amount of money spent on ads"
            value={totalSpend}
            loading={loading}
          />
        </Grid.Cell>
        <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 2, lg: 4, xl: 4 }}>
          <StatBox
            title="ROAS"
            description="Return On Ad Spend - how much revenue was generated for each dollar spent on ads"
            value={roas}
            loading={loading}
          />
        </Grid.Cell>
        <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 2, lg: 4, xl: 4 }}>
          <StatBox
            title="CAC"
            description="Customer Acquisition Cost - average cost to acquire a new customer"
            value={cac}
            loading={loading}
          />
        </Grid.Cell>
      </Grid>

      <Grid>
        <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 2, lg: 4, xl: 4 }}>
          <StatBox
            title="Impressions"
            description="Number of times your ad was shown to people"
            value={impressions}
            loading={loading}
          />
        </Grid.Cell>
        <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 2, lg: 4, xl: 4 }}>
          <StatBox
            title="Clicks"
            description="Number of times your someone clicked on your ad"
            value={totalClicks}
            loading={loading}
          />
        </Grid.Cell>
        <Grid.Cell columnSpan={{ xs: 6, sm: 6, md: 2, lg: 4, xl: 4 }}>
          <StatBox
            title="Conversion rate"
            description="What % of people that clicked the ad ended up converting (purchasing)"
            value={conversionRate}
            loading={loading}
          />
        </Grid.Cell>
      </Grid>
    </BlockStack>
  );
};
